import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { DayActivityBlock } from '../blocks/DayActivityBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const DayActivitiesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { dayActivities } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {dayActivities.map((item, index) => (
        <DayActivityBlock key={index} dayActivity={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default DayActivitiesLayer
